<template>
  <div class="activate-vip compatible-sticky">
    <img class="title-img" src="/images/vip/activate-vip06.png" alt="" />
    <div class="container">
      <div class="content">
        <div class="info-box" v-if="!activateResult">
          <h3>VIP券码： {{ vipData.num }}</h3>
          <div class="user-info">
            <h4>{{ vipStatusText }}</h4>
            <router-link v-if="isLogin && isValid" to="/account/login-bySMS"
              >切换账号></router-link
            >
          </div>
        </div>
        <ul v-if="!activateStatus.statementShow && !activateResult">
          <h5>VIP课程包选择：</h5>
          <li
            :class="{
              active: memberPackageIds.indexOf(item.correlationId) > -1
            }"
            v-for="(item, index) in couponCourse.goods"
            :key="index"
            @click="correlationIdHandel(item.correlationId)"
          >
            <h6>{{ item.goodsName }}</h6>
            <span></span>
          </li>
        </ul>
        <div class="result-box" v-if="activateResult">
          <img class="result-img" src="/images/vip/activate-vip10.png" alt="" />
          <h6>恭喜您成功开通VIP</h6>
          <p>账号：{{ userInfo.phoneNum }}</p>
        </div>
        <img class="bottom-img" src="/images/vip/activate-vip07.png" alt="" />
      </div>
    </div>
    <button
      class="activate-button"
      :class="{ active: activateStatus.classActive }"
      v-if="isValid"
      @click="isActivateShowHandler"
    >
      {{ activateStatus.text }}
    </button>
    <div class="compatible"></div>
    <div class="statement" v-if="activateStatus.statementShow">
      <div class="statement-bg"></div>
      <div class="statement-text">
        1. 扫码VIP券，点击兑换即可兑换<br />
        （未登录时需先进行登录）。<br />
        2.兑换成功后，下载智伴优学APP，体验VIP课程包。
      </div>
      <h2>兑换VIP步骤</h2>
      <img class="statement-icon" src="/images/vip/activate-vip03.png" alt="" />
    </div>
    <transition name="fade">
      <div v-if="isActivateShow" class="activate-box">
        <div class="shadow"></div>
        <div class="activate-info">
          <div>
            <p>确认为手机号：</p>
            <h1>{{ userInfo.phoneNum }}激活VIP？</h1>
            <p>推荐人：</p>
            <h1>{{ referrer }}</h1>
          </div>
          <div class="button-box">
            <button class="cancel" @click="isActivateShow = false">取消</button>
            <button class="ok" @click="activateHandler">确定</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { isEmpty, without } from 'lodash'
const vipStatusData = {
  // status::0-无效 1-有效 2-已使用 3-已赠送 4-注销
  0: '卡券已失效',
  1: '有效卡券',
  2: '券码已经被使用~',
  3: '券码已赠送~',
  4: '券码已经被注销~'
}
export default {
  data () {
    return {
      vipData: {},
      couponCourse: {
        goods: [],
        total: 0
      },
      memberPackageIds: [],
      isActivateShow: false,
      activateResult: false
    }
  },
  async created () {
    await this.loadData()
    this.loadCouponCourse()
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow'
    }),
    //卡券信息
    loadData () {
      return this.$api
        .payment_v1_coupon_detail_get({
          params: {
            num: this.couponNum
          }
        })
        .then(e => {
          this.vipData = e || {}
        })
    },
    //VIP课程包
    loadCouponCourse () {
      return this.$api
        .payment_v1_sys_coupon_course_category_goodsInfo_get({
          params: {
            id: this.vipData.couponCategoryId,
            pageNo: 1,
            pageSize: 3
          }
        })
        .then(e => {
          if (e) {
            this.couponCourse = e
            if (this.vipData.memberPackageChooseLimit == 3) {
              for (let i = 0; i < this.vipData.memberPackageChooseLimit; i++) {
                // if (i > 3) return
                this.memberPackageIds.push(
                  this.couponCourse.goods[i].correlationId
                )
              }
            }
          }
        })
    },
    correlationIdHandel (id) {
      //产品需求，限制和课程总数相等，只能全选
      if (
        this.vipData.memberPackageChooseLimit == this.couponCourse.goods.length
      ) {
        return
      }
      // if (this.memberPackageIds.indexOf(id) > -1) {
      //   this.memberPackageIds = without(this.memberPackageIds, id)
      // } else {
      //   if (this.vipData.memberPackageChooseLimit <= this.memberPackageIds.length) {
      //     this.$createToast({
      //       txt: `该卡券仅能激活${this.vipData.memberPackageChooseLimit}个课程`,
      //       type: 'txt',
      //       time: 1500
      //     }).show()
      //     return
      //   }
      this.memberPackageIds = [id]
      // }
    },
    isActivateShowHandler () {
      if (!this.isLogin) {
        this.$router.push('/account/login-bySMS')
      } else if (this.activateResult) {
        location.href = this.downloadPath
      } else if (this.memberPackageIds.length <= 0) {
        this.$createToast({
          txt: '请选择VIP课程包',
          type: 'txt',
          time: 1500
        }).show()
      } else if (this.activateStatus.classActive) {
        this.isActivateShow = true
      }
    },
    //激活兑换券
    activateHandler () {
      this.setLoading({
        show: true,
        text: '正在激活'
      })
      this.$api
        .payment_v1_coupon_activate_post({
          data: {
            num: this.vipData.num,
            useUser: this.userInfo.phoneNum,
            memberPackageIds: this.memberPackageIds
          }
        })
        .then(e => {
          this.setLoading({
            show: false
          })
          this.activateResult = !!e
          this.isActivateShow = false
        })
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'auth/userInfo',
      isVisitor: 'auth/isVisitor',
      downloadPath: 'externalInterface/downloadApp',
      isWeak: 'auth/isWeak',
      validContextInfo: 'auth/validContextInfo'
    }),
    couponNum () {
      return this.$route.params.num
    },
    referrer () {
      //无强绑定关系时,关系绑定后端处理
      //无强绑定关系时，显示将绑定的推荐人,已有强绑定关系时，显示已绑定的推荐人
      if (this.isWeak) {
        return this.vipData.owner || this.vipData.belonger || '小智伴'
      } else {
        return this.validContextInfo && this.validContextInfo.invitePhoneNum
          ? this.validContextInfo.invitePhoneNum
          : this.vipData.owner || this.vipData.belonger
      }
    },
    isValid () {
      // status:0-无效 1-有效 2-已使用 3-已赠送 4-注销
      // enabled和status都为1 就是可用
      // 1. 待使用 - owner=当前登录人
      // 2. 已赠送 - belonger != owner
      //useUser卡券使用用户
      return (
        (this.vipData.status == 1 || this.vipData.status == 3) &&
        this.vipData.enabled == 1
      )
    },
    isLogin () {
      return !this.isVisitor && !isEmpty(this.userInfo)
    },
    vipStatusText () {
      return !this.isValid
        ? vipStatusData[this.vipData.status]
        : this.isLogin
        ? `兑换账号：${this.userInfo.phoneNum}`
        : '请先登录兑换账号哟~'
    },
    activateStatus () {
      if (!this.isLogin) {
        return {
          statementShow: true,
          text: '马上登录兑换',
          classActive: true
        }
      } else if (this.activateResult) {
        return {
          statementShow: false,
          text: '下载APP体验智伴优学VIP课程',
          classActive: true
        }
      } else if (!this.isValid) {
        return {
          statementShow: true,
          text: vipStatusData[this.vipData.status],
          classActive: false
        }
      } else if (
        this.couponCourse.total <= 0 ||
        this.memberPackageIds.length <= 0
      ) {
        return {
          statementShow: false,
          text: '马上兑换',
          classActive: false
        }
      } else {
        return {
          statementShow: false,
          text: '马上兑换',
          classActive: true
        }
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}

.activate-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.activate-box .shadow {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 1);
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
}

.activate-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 240px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  padding: 25px 25px 24px 20px;
  box-sizing: border-box;
  margin: 0 auto;
}

.activate-info p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-bottom: 9.5px;
}

.activate-info h1 {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 66, 121, 1);
  line-height: 20px;
  padding-bottom: 20px;
}

.button-box {
  display: flex;
  justify-content: space-between;
}

.button-box button {
  display: block;
  width: 92px;
  height: 34px;
  background: rgba(202, 202, 202, 1);
  border-radius: 4px;
  line-height: 34px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.button-box button.ok {
  background: linear-gradient(
    180deg,
    rgba(255, 214, 49, 1),
    rgba(254, 162, 53, 1)
  );
  color: rgba(203, 91, 5, 1);
}

.activate-vip {
  height: 100vh;
  background-image: url('/images/vip/activate-vip05.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  padding-top: 37.5px;
  box-sizing: border-box;
}

.title-img {
  display: block;
  width: 293.5px;
  height: 110.5px;
  margin: 0 auto 23px;
}

.container {
  width: 319px;
  background-image: url('/images/vip/activate-vip04.png');
  background-repeat: no-repeat;
  background-size: 319px 47px;
  background-position: 0 0;
  padding-top: 47px;
  margin: 0 auto;
}

.content {
  width: 280px;
  background-color: #fdebd8;
  margin: -2px auto 0;
  padding: 16px 13px 13px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0px 6px 10px 0px rgba(96, 42, 15, 0.58);
}

.content .bottom-img {
  display: block;
  width: 280px;
  height: 5px;
  position: absolute;
  left: 0;
  bottom: -4px;
}

.content::after {
  content: '';
  width: 14.5px;
  height: 28.5px;
  background-image: url('/images/vip/activate-vip02.png');
  background-size: 14.5px 28.5px;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  right: -25px;
  top: 38.5px;
}

ul li + li {
  margin-top: 7px;
}

.info-box {
  width: 256px;
  height: 72.5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url('/images/vip/activate-vip01.png');
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  padding: 12px 15.5px 10px 16px;
  box-sizing: border-box;
  /* box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15); */
}

h3 {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 66, 121, 1);
  line-height: 20px;
  overflow: hidden;
  /*超出部分隐藏*/
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  white-space: nowrap;
  /*规定段落中的文本不进行换行 */
}

.user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h4 {
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 66, 121, 1);
  line-height: 20px;
}

.container a {
  width: 66px;
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  color: rgba(228, 136, 55, 1);
  line-height: 10px;
}

h5 {
  width: 250.5px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(228, 136, 55, 1);
  line-height: 20px;
  margin: 10.5px auto 11px;
}

ul li {
  width: 250.1px;
  height: 36px;
  background-color: #fff;
  padding: 0 15.5px 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  /* line-height: 36px; */
}

li h6 {
  font-size: 14px;
  font-weight: 400;
  color: rgba(194, 194, 194, 1);
  line-height: 20px;
  overflow: hidden;
  /*超出部分隐藏*/
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
  white-space: nowrap;
  /*规定段落中的文本不进行换行 */
  transition: all 0.3s;
}

span {
  display: block;
  width: 16px;
  height: 16px;
  background-image: url('/images/vip/activate-vip08.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  transition: all 0.3s;
}

li.active h6 {
  color: #244352;
}

li.active span {
  background-image: url('/images/vip/activate-vip09.png');
}

.result-box {
  width: 245px;
  margin: 12.5px auto 0;
  transition: all 0.3s;
}

.result-img {
  display: block;
  width: 102.5px;
  height: 102.5px;
  margin: 0 auto;
}

.result-box h6 {
  font-size: 14px;
  font-weight: 500;
  color: rgba(228, 136, 55, 1);
  line-height: 20px;
  text-align: center;
  padding: 16.5px 0 11.5px;
}

.result-box p {
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}

.activate-button {
  display: block;
  width: 280px;
  height: 40px;
  background: linear-gradient(
    180deg,
    rgba(150, 150, 150, 1),
    rgba(219, 217, 217, 1)
  );
  border-radius: 5px;
  margin: 23px auto 0;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  line-height: 40px;
  transition: all 0.3s;
}

.activate-button.active {
  background: linear-gradient(
    180deg,
    rgba(255, 214, 49, 1),
    rgba(254, 162, 53, 1)
  );
  color: rgba(203, 91, 5, 1);
  box-shadow: 0px 5px 1px 0px #cb5b05;
}

.statement {
  position: absolute;
  width: 319px;
  height: 77.25px;
  border-radius: 8px;
  left: 50%;
  top: 442px;
  transform: translateX(-50%);
}

.statement-bg {
  width: 319px;
  height: 77.25px;
  border-radius: 8px;
  background: rgba(216, 69, 65, 1);
  opacity: 0.3;
  position: absolute;
  top: 0;
  left: 0;
}

.statement-text {
  width: 285px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  position: absolute;
  bottom: 11.5px;
  left: 50%;
  transform: translateX(-50%);
}

h2 {
  font-size: 14px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  position: absolute;
  left: 18px;
  top: -8px;
}

.statement-icon {
  display: block;
  width: 37.5px;
  height: 37.5px;
  position: absolute;
  top: -18px;
  right: 8px;
}
</style>
